import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  SimpleGrid,
  Icon,
  Button,
  Spinner,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, CalendarIcon, TimeIcon } from '@chakra-ui/icons';
import { BiBrain } from 'react-icons/bi'; // Make sure react-icons/bi is installed
import { MarketStatus } from '../components/MarketStatus';

export const Home: React.FC = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'gray.800'); // Add this line
  const [markets, setMarkets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarketStatus = async () => {
      try {
        const response = await fetch(
          'https://www.alphavantage.co/query?function=MARKET_STATUS&apikey=Q8ZI5UJX6WTQ6KW0'
        );
        const data = await response.json();
        setMarkets(data.markets || []);
      } catch (error) {
        console.error('Failed to fetch market status:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMarketStatus();
  }, []);

  const features = [
    {
      title: 'Market Search',
      description: 'Search and analyze stocks with real-time data',
      icon: SearchIcon,
      path: '/market-search'
    },
    {
      title: 'Earnings Calendar',
      description: 'Track upcoming earnings and IPO events',
      icon: CalendarIcon,
      path: '/earnings-calendar'
    },
    {
      title: 'Holdings',
      description: 'Manage and track your portfolio',
      icon: TimeIcon,
      path: '/holdings'
    },
    {
      title: 'AI Advisor',
      description: 'Get AI-powered market insights',
      icon: BiBrain,
      path: '/advisor'
    }
  ];

  return (
    <Container maxW="container.xl" py={12}>
      <VStack spacing={8} align="stretch">
        <VStack spacing={4} textAlign="center">
          <Heading
            fontSize={{ base: "4xl", md: "6xl" }}
            bgGradient="linear(to-r, blue.400, purple.500)"
            bgClip="text"
          >
            Welcome to Finomo
          </Heading>
          <Text fontSize={{ base: "xl", md: "2xl" }} color="gray.500">
            Your all-in-one financial market analysis platform
          </Text>
        </VStack>

        <Box>
          <Heading size="lg" mb={6}>Global Market Status</Heading>
          {loading ? (
            <Box textAlign="center" py={8}>
              <Spinner size="xl" />
            </Box>
          ) : (
            <MarketStatus markets={markets} />
          )}
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8}>
          {features.map((feature) => (
            <Box
              key={feature.title}
              bg={bgColor} // Now bgColor is defined
              p={6}
              borderRadius="xl"
              boxShadow="xl"
              cursor="pointer"
              onClick={() => navigate(feature.path)}
              _hover={{ transform: 'translateY(-4px)', boxShadow: '2xl' }}
              transition="all 0.2s"
            >
              <VStack spacing={4}>
                <Icon as={feature.icon} boxSize={8} color="blue.500" />
                <Heading size="md">{feature.title}</Heading>
                <Text color="gray.500">{feature.description}</Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};
